import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import MainPage from './components/app.vue'


import './assets/css/style.css'
import './assets/css/element-ui.css'
import layer from './assets/js/layer.js'
import './assets/css/layer.css'
import './plugins/axios.js'
import commit from './commit/commit'
import global_info from './assets/js/url.js' //1
import {
  isAuth
} from './assets/js/isAlon'

import moment from 'moment'
import axios from 'axios'
import qs from "qs"
import store from './store/store'

import Vuex from 'vuex'
import router from './router/index'
// app品牌下拉框组件
// 面包屑
import SubTitle from "./components/subTitle/index.vue"
import https from "./plugins/https"
Vue.component("SubTitle",SubTitle)
Vue.use(Vuex)
Vue.prototype.$commit = commit;
Vue.prototype.qs = qs;
Vue.prototype.$https = https
Vue.prototype.GLOBAL = global_info;
const loadingTxt = "数据加载中,请稍后..."
Vue.prototype.$loadingTxt = loadingTxt

// Vue.component('v-distpicker', VDistpicker)
Vue.use(moment);
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn'); 
Vue.prototype.$moment = moment; //赋值使用

Vue.prototype.$axios = axios
Vue.prototype.isAuth = isAuth // 权限方法


Vue.use(ElementUI);

Vue.config.silent = true
// import layer from "layui-layer";

window.routeBool = false
Vue.prototype.validForbid = function (value, number = 255) {
  value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "");
  if (value.length >= number) {
    this.$message({
      type: "warning",
      message: `输入内容不能超过${number}个字符`
    });
  }
  return value;
}
const on = Vue.prototype.$on

Vue.prototype.$on = function (event, func) {
  let previous = 0
  let newFunc = func
  if (event === 'click') {
    newFunc = function () {
      const now = new Date().getTime()
      if (previous + 1000 <= now) {
        func.apply(this, arguments)
        previous = now
      }
    }
  }
  on.call(this, event, newFunc)
}


// router.beforeEach((to, from, next) => {
//   // 确定用户是否已登录  
//   console.log(to)
//   const hasToken = localStorage.getItem("token")
//   if(hasToken){
//     next()
//   }else{
//     next("/login")
//   }


//   // if (!hasToken && to.path!="/sharee") {
//   //   next("/login")
//   // }else{
//   //   next()
//   // }
// })


// // 全局路由导航拦截
// router.beforeEach((to, from, next) => {
//   // ...
//   if (to.path === '/login') { // 如果是登录页面路径，就直接next()
//     alert("拦截登录页面进入")
//     next()
//   }
// })



new Vue({
  el: '#app',
  router,
  store,
  render: h => h(MainPage),
});


// WEBPACK FOOTER //
// ./src/main.js